import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=2ac4048a&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=2ac4048a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4048a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac4048a')) {
      api.createRecord('2ac4048a', component.options)
    } else {
      api.reload('2ac4048a', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=2ac4048a&scoped=true", function () {
      api.rerender('2ac4048a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/SignUp.vue"
export default component.exports